var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileIcon = function SvgFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file-icon_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BEBEBE",
    mask: "url(#file-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.615 21c-.46 0-.844-.154-1.152-.462A1.565 1.565 0 0 1 5 19.385V4.615c0-.46.154-.844.463-1.153A1.565 1.565 0 0 1 6.615 3h8.116L19 7.27v12.115c0 .46-.154.844-.462 1.152a1.565 1.565 0 0 1-1.153.463H6.615Zm0-1h10.77a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423V7.769h-3.77V4H6.616a.588.588 0 0 0-.423.192.588.588 0 0 0-.192.423v14.77c0 .153.064.294.192.423.129.128.27.192.423.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19c.988 0 1.818-.339 2.49-1.016.674-.678 1.01-1.49 1.01-2.436v-4.642h-1.083v4.642c0 .662-.232 1.234-.696 1.715-.464.482-1.038.723-1.721.723-.68 0-1.252-.241-1.718-.723a2.383 2.383 0 0 1-.699-1.715v-5.54c0-.268.09-.501.267-.698a.865.865 0 0 1 .67-.296c.274 0 .5.099.675.296.175.197.263.43.263.699v5.539h1.084v-5.54c0-.54-.193-1.01-.577-1.41C12.08 8.2 11.599 8 11.02 8s-1.06.2-1.444.599c-.385.399-.577.869-.577 1.41v5.539c0 .946.338 1.758 1.012 2.436C10.688 18.66 11.517 19 12.5 19Z"
  }))));
};
export default SvgFileIcon;